const weekdays_options = [
  { label: "Poniedziałek", value: "1" },
  { label: "Wtorek", value: "2" },
  { label: "Środa", value: "3" },
  { label: "Czwartek", value: "4" },
  { label: "Piątek", value: "5" },
  { label: "Sobota", value: "6" },
  { label: "Niedziela", value: "0" },
];

export const getWeekDays = (values) =>
  weekdays_options
    .filter(({ value }) => values.includes(Number(value)))
    .map(({ label }) => label)
    .join(", ");

export default weekdays_options;
